// Copyright (c) 2025 WSO2 LLC. (https://www.wso2.com).
//
// WSO2 LLC. licenses this file to you under the Apache License,
// Version 2.0 (the "License"); you may not use this file except
// in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

export const Messages = {
  success: {
    updateRecord: "Successfully updated the record",
    saveRecords: "Successfully saved the records",
    updateRecords: "Updated successfully",
  },
  error: {
    fetchRecords: "Unable to retrieve timesheet logs",
    sendRecords: "Unable to save timesheet records",
    otExceeds: "This entries exceeds the available overtime quota",
    updateRecords: "Unable to update the records",
    insufficientPrivileges: "Insufficient Privileges",
    fetchPrivileges: "Failed to fetch Privileges",
    fetchEmployees: "Unable to fetch employee information.",
  },
  warning: {},
  info: {
    adminHelperAlert: " Use the filter to get employee timesheet information",
    noRecords: "No records found",
    useFilter: "Use the filter to find records ",
    addEntries: "Add entries to get started",
    loadingText: "Loading...",
  },
};
